// extracted by mini-css-extract-plugin
export default {"twoLines":"LoginCreate_twoLines__2mWeY","select":"LoginCreate_select__2os0i","modal":"LoginCreate_modal__Cxjqg","headerLogo":"LoginCreate_headerLogo__WTnmC"};